import React, { useRef } from 'react';

const Toolbar = ({ onRefresh, onImport, onExport, onAddCategory, onEditCategory, onAddSubcategory }) => {
  const fileRef = useRef(null);

  const triggerImport = () => fileRef.current?.click();
  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const text = await file.text();
    onImport(text);
    e.target.value = ''; // reset
  };

  const Button = ({ children, onClick }) => (
    <button type="button" className="users-manager-toolbar-btn" onClick={onClick}>
      {children}
    </button>
  );

  return (
    <div className="users-manager-toolbar-inner">
      <Button onClick={onRefresh}>Refresh</Button>
      <Button onClick={onAddCategory}>Add New User</Button>
      <Button onClick={triggerImport}>Import</Button>
      <input ref={fileRef} type="file" accept="application/json" style={{ display: 'none' }} onChange={handleFile} />
      <Button onClick={onExport}>Export</Button>
    </div>
  );
};


export default Toolbar;
